import api from '@/api/index.js'

const account_money_claims = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_ACCOUNT_MONEY_CLAIMS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_ACCOUNT_MONEY_CLAIMS: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_ACCOUNT_MONEY_CLAIMS_ERROR: (state, error) => {
      state.error = error;
      state.loading = false;
    }
  },

  actions: {
    LoadAccountMoneyClaims({commit}, accountID) {
      commit('SET_ACCOUNT_MONEY_CLAIMS_ERROR', null)
      commit('SET_ACCOUNT_MONEY_CLAIMS_LOADING', true)
      return api.get(`accounts/${accountID}/money-claims?limit=150&offset=0`)
        .then((response) => {
          commit('SET_ACCOUNT_MONEY_CLAIMS', response)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_MONEY_CLAIMS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    }
  },
}

export default account_money_claims
